import api from "../../../shared/services/api";

// Chat por sessão do WhatsApp não-oficial (wppconnect).
// Base: /api/whatsapp/chat — envelope { success, data, error }.
const BASE = "/whatsapp/chat";

function unwrap(resp) {
  return resp?.data?.data ?? resp?.data ?? null;
}

export async function listSessoes() {
  const resp = await api.get(`${BASE}/sessoes`);
  const d = unwrap(resp);
  return Array.isArray(d) ? d : [];
}

export async function getConfig(sessaoId) {
  const resp = await api.get(`${BASE}/${sessaoId}/config`);
  return unwrap(resp) || {};
}

export async function saveConfig(sessaoId, body) {
  const resp = await api.put(`${BASE}/${sessaoId}/config`, body);
  return unwrap(resp) || {};
}

export async function listGrupos(sessaoId) {
  const resp = await api.get(`${BASE}/${sessaoId}/grupos`);
  const d = unwrap(resp);
  return Array.isArray(d) ? d : [];
}

/**
 * @returns {Promise<{ items: Array, nextCursor: string|null, hasMore: boolean }>}
 */
export async function listConversas(sessaoId, params = {}) {
  const query = {};
  if (params.limit) query.limit = params.limit;
  if (params.cursor) query.cursor = params.cursor;
  if (params.busca && params.busca.trim()) query.busca = params.busca.trim();
  if (params.filtro && params.filtro !== "todas") query.filtro = params.filtro;

  const resp = await api.get(`${BASE}/${sessaoId}/conversas`, { params: query });
  const payload = unwrap(resp) || {};
  const items = Array.isArray(payload) ? payload : (payload.items ?? payload.conversas ?? []);
  return {
    items,
    nextCursor: Array.isArray(payload) ? null : (payload.nextCursor ?? payload.cursor ?? null),
    hasMore: Array.isArray(payload) ? false : (payload.hasMore ?? false),
  };
}

export async function criarConversa(sessaoId, telefone) {
  const resp = await api.post(`${BASE}/${sessaoId}/conversas`, { telefone });
  return unwrap(resp);
}

export async function getConversa(sessaoId, cid) {
  const resp = await api.get(`${BASE}/${sessaoId}/conversas/${cid}`);
  return unwrap(resp);
}

/**
 * @returns {Promise<{ items: Array, nextCursor: string|null, hasMore: boolean }>}
 */
export async function listMensagens(sessaoId, cid, params = {}) {
  const query = {};
  if (params.limit) query.limit = params.limit;
  if (params.cursor) query.cursor = params.cursor;
  const resp = await api.get(`${BASE}/${sessaoId}/conversas/${cid}/mensagens`, { params: query });
  const payload = unwrap(resp) || {};
  const items = Array.isArray(payload) ? payload : (payload.items ?? payload.mensagens ?? []);
  return {
    items,
    nextCursor: Array.isArray(payload) ? null : (payload.nextCursor ?? payload.cursor ?? null),
    hasMore: Array.isArray(payload) ? false : (payload.hasMore ?? false),
  };
}

export async function enviarTexto(sessaoId, cid, texto) {
  const resp = await api.post(`${BASE}/${sessaoId}/conversas/${cid}/mensagens`, { texto });
  return unwrap(resp);
}

export async function enviarMidia(sessaoId, cid, file, legenda) {
  const form = new FormData();
  form.append("file", file);
  if (legenda) form.append("legenda", legenda);
  const resp = await api.post(`${BASE}/${sessaoId}/conversas/${cid}/midia`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 180000,
  });
  return unwrap(resp);
}

export async function marcarLido(sessaoId, cid) {
  const resp = await api.post(`${BASE}/${sessaoId}/conversas/${cid}/marcar-lido`);
  return unwrap(resp);
}

// ───────── helpers compartilhados pela UI ─────────

export function formatarTelefone(valor) {
  if (!valor) return "";
  const d = String(valor).replace(/\D/g, "");
  if (d.startsWith("55") && (d.length === 12 || d.length === 13)) {
    const ddd = d.slice(2, 4);
    const resto = d.slice(4);
    const parte1 = resto.length === 9 ? resto.slice(0, 5) : resto.slice(0, 4);
    const parte2 = resto.length === 9 ? resto.slice(5) : resto.slice(4);
    return `+55 (${ddd}) ${parte1}-${parte2}`;
  }
  return d ? `+${d}` : String(valor);
}

export function nomeConversa(conversa) {
  if (!conversa) return "Sem nome";
  if (conversa.is_grupo) return conversa.nome_grupo || conversa.push_name || "Grupo";
  return (
    conversa.push_name ||
    conversa.cliente_nome ||
    formatarTelefone(conversa.telefone) ||
    (conversa.remote_jid ? String(conversa.remote_jid).split("@")[0] : "Sem nome")
  );
}
